<script lang="ts"></script>

<button on:click class="gw-video-player-button">
    <slot />
</button>

<style>
    .gw-video-player-button {
        display: flex;
        position: relative;
        box-sizing: border-box;
        flex-direction: row;
        flex-shrink: 0;
        align-items: center;
        padding: var(--gw-vp-button-padding);
        transform: scale(var(--gw-vp-button-default-scale, 1));
        transition: all var(--gw-default-transition);
        border: none;
        border-radius: var(--gw-vp-button-radius);
        background-color: transparent;
        cursor: pointer;
        pointer-events: auto;
        touch-action: manipulation;
    }
    .gw-video-player-button:hover {
        background-color: var(--gw-vp-main-color);
    }
</style>
